import * as R from "ramda";

export function getFilteredItems(items, filter) {
  return R.filter(R.where({ filters: R.includes(filter) }), items);
}

export function getHighlightedItems(items) {
  return items.filter((item) => item.highlighted);
}

export function getNonHighlightedItems(items) {
  return items.filter((item) => !item.highlighted);
}
